const OPDMain = () =>
    import ( /* webpackChunkName: "OPD" */ "@/components/OPDNew/OPD/OPDMain");
const MedicalCertificate = () =>
    import ( /* webpackChunkName: "OPD" */ "@/components/OPDNew/MedicalCertificate");
const OPDReports = () =>
    import ( /* webpackChunkName: "OPD" */ "@/components/OPDNew/OPDReports");
const PastMedicalHistory = () =>
    import ( /* webpackChunkName: "OPD" */ "@/components/OPDNew/PastMedicalHistory");
const PresentMedication = () =>
    import ( /* webpackChunkName: "OPD" */ "@/components/OPDNew/PresentMedication");
const Vaccine = () =>
    import ( /* webpackChunkName: "OPD" */ "@/components/OPDNew/vaccine/OPDVaccine");
const BoxView = () =>
    import ( /* webpackChunkName: "OPD" */ "@/components/OPDNew/vaccine/BoxViewVaccine");
const TableView = () =>
    import ( /* webpackChunkName: "OPD" */ "@/components/OPDNew/vaccine/TableViewVaccine");
const ReceivedVaccine = () =>
    import ( /* webpackChunkName: "OPD" */ "@/components/OPDNew/vaccine/ReceivedVaccine");
const Masters = () =>
    import ( /* webpackChunkName: "OPD" */ "@/components/OPDNew/vaccine/Masters");
import opdnewRoutes from "./opdNew";
const OPDProcedure = () =>
    import ( /* webpackChunkName: "OPD" */ "@/components/OPDNew/Procedure/ProcedureMain");
const BasicPrescription = () =>
    import ( /* webpackChunkName: "OPD" */ "@/components/OPDNew/BasicOPD/BasicPrescription");
const BasicOPD = () =>
    import ( /* webpackChunkName: "OPD" */ "@/components/OPDNew/BasicOPD/BasicPrescription");
const PatientBroughtDead = () =>
    import ( /* webpackChunkName: "OPD" */ "@/components/OPDNew/BasicOPD/PatientBroughtDead");
const CapturePrescription = () =>
    import ( /* webpackChunkName: "OPD" */ "@/components/OPDNew/capture-prescription/capture-prescription");
const PatientGallery = () =>
    import ( /* webpackChunkName: "OPD" */ "@/components/OPDNew/PatientGallery");
export default [{
        path: "",
        // redirect: {
        //     name: "OPDLeftSidebar.create-opd"
        // }
    },
    {
        path: "create-opd",
        component: OPDMain,
        name: "OPDLeftSidebar.create-opd",
        // redirect: {
        //     name: "opd.create-opd.history"
        // },
        children: opdnewRoutes
    },
    {
        path: "medical-certificate",
        component: MedicalCertificate,
        name: "OPDLeftSidebar.medical-certificate"
    },
    {
        path: "reports",
        component: OPDReports,
        name: "OPDLeftSidebar.reports"
    },
    {
        path: "OPDProcedure",
        component: OPDProcedure,
        name: "OPDLeftSidebar.OPDProcedure"
    },
    {
        path: "past-medical-history",
        component: PastMedicalHistory,
        name: "OPDLeftSidebar.past-medical-history"
    },
    {
        path: "present-medication",
        component: PresentMedication,
        name: "OPDLeftSidebar.present-medication"
    },
    {
        path: "basic-prescription",
        component: BasicPrescription,
        name: "OPDLeftSidebar.BasicPrescription"
    },
    {
        path: "BasicOPD",
        component: BasicOPD,
        name: "OPDLeftSidebar.BasicOPD"
    },
    {
        path: "PatientBroughtDead",
        component: PatientBroughtDead,
        name: "OPDLeftSidebar.PatientBroughtDead"
    },
    {
        path: "CapturePrescription",
        component: CapturePrescription,
        name: "OPDLeftSidebar.CapturePrescription"
    },
    {
        path: "patient-gallery",
        component: PatientGallery,
        name: "OPDLeftSidebar.OPDPatientGallery"
    },
    {
        path: "vaccine",
        component: Vaccine,
        name: "OPDLeftSidebar.vaccine",
        children: [{
                path: "",
                redirect: {
                    name: "OPDLeftSidebar.vaccine.boxView"
                }
            },
            {
                path: "box-view",
                component: BoxView,
                name: "OPDLeftSidebar.vaccine.boxView"
            },
            {
                path: "table-view",
                component: TableView,
                name: "OPDLeftSidebar.vaccine.tableView"
            },
            {
                path: "received-vaccine",
                component: ReceivedVaccine,
                name: "OPDLeftSidebar.vaccine.receivedVaccine"
            },
            {
                path: "masters",
                component: Masters,
                name: "OPDLeftSidebar.vaccine.masters"
            }
        ]
    }
];